export function sanitizarNumero(n, MIN, MAX) {
  return Math.min(Math.max(Number(n || 1), MIN), MAX)
}
